import React from 'react';
import './Events.css';

import { Event, Heading } from '../../../components';
import { events } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Events = () => {

  return (
    <section className='events'>

      {/* Section heading */}
      <Heading title={'Upcoming Events'} subTitle={'Community Engagement'} />

      <div className='event-slider'>

        <Swiper

          // Install Swiper modules
          modules={[Autoplay]} // Enable Autoplay
          spaceBetween={10} // Space between slides
          loop={true} // Infinite Looping
          autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-slide every 4 seconds

          // Responsive Breakpoints
          breakpoints={{
            768: { slidesPerView: 1 }, // 1 slides for tablets
            991: { slidesPerView: 2 }, // 2 slides for larger screens
          }}

        >
          {/* Map over the events array to render each event */}
          {events.map((event) => {

            return (
              <SwiperSlide key={event.id}>

                <Event event={event} />

              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}

export default Events;